module.exports = __webpack_public_path__ + "static/media/protocol_2024_10_24.4c91a855.htm";